import { useConfig } from '@hooks/use-config/index';

const WP_ASSETS_CONFIG_URL = "wp-json/smassets/v1/values/";

export const useAssetsConfig = () => {
    return useConfig(WP_ASSETS_CONFIG_URL);
}